import {
    FETCH_DATA_PROJECTS_REQUEST,
    FETCH_DATA_PROJECTS_SUCCESS,
    FETCH_DATA_PROJECTS_FAILURE,
} from '../../actions/projects/get-projects-actions';

const initialState = {
    list: [],
    isLoading: false,
    error: null,
    meta: null
};

const ProjectsReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case FETCH_DATA_PROJECTS_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case FETCH_DATA_PROJECTS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                list: action.payload.values,
                meta: action.payload.meta
            };
        case FETCH_DATA_PROJECTS_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };
        default:
            return state;
    }
};

export default ProjectsReducer;